<template>
<div id="app">
  <app-header></app-header>
  <router-view/>
  <app-footer></app-footer>
  <login></login>
</div>
</template>

<script>

import AppHeader from './components/appHeader.vue'
import AppFooter from './components/appFooter.vue'
import Login from './components/login'
export default {
  components: {
    Login,
    AppFooter,
    AppHeader},
  name: 'App'
}
</script>

<style>
/*Base Style*/
/*-----------------------------------------------------------------------------------
  Template Name:             style.css
  Template URI:              ....................................
  Description:               ....................................
  CoDer :                    ....................................
  CoDer's Site URL:          ....................................
  Version:                   1.0
  Creation date:             19.10.17

-----------------------------------------------------------------------------------*/
/*** ===================================/***
   TABLE OF CONTENT
/*** ===================================/***

1. Basic
  + html
  + color
  + button
  + line

3. Typography
  + title
  + txt
  + link
  + list
  + tables
  + fa icon

3. Form
  + Input
  + textarea
  + select
  + submit

3.  UI Elements
  + Popup/Notification
+ Search
  + Icon

/* ===================================/***
   Basic
/*** ===================================***/
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: mft_narkisclassic;
  src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
  font-style: normal;
  font-weight: bold;
}

/**========== Html ==========**/
*, *:before, *:after {
box-sizing: border-box;
}
html {direction: ltr;}
html, body{margin: 0; height:100%;}
body{
  min-width: ;
  font-size: 16px;
  line-height: 19px;
  color: #646464;
  font-weight: 400;
  font-family: 'Roboto', mft_narkisclassic, Work Sans, sans-serif;
  overflow: hidden;
  overflow-y: auto;
}
body.home{background: #fff;}
body.rest{background: #f6f6f6;}
#app{height: 100vh;}
#home{
height: 95%;
}
#header{
display: block;
content: '';
clear: both;
}
iframe{ width:100%; border:0;}
section { position: relative;}
article, section, footer, header, figure, aside, hgroup, nav{display:block;}
header,nav,article,footer,section,aside,figure,figcaption{display:block}
button {outline: none; border: none; box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.33);}
img {border: 0px; margin: 0px;}
a>img {display: block;}

a, textarea.form-control, .bt,
input.form-control, button.form-control, select.form-control,
input[type="text"], input[type="password"], input[type="datetime"], input[type="datetime-local"], input[type="date"], input[type="month"],
input[type="time"], input[type="week"], input[type="number"], input[type="email"], input[type="url"], input[type="search"], input[type="tel"],
input[type="color"], input[type="submit"], select, textarea, button, .sidebar ul li, .top_header nav#main-nav ul li.menu-item, .pricing .s_pricing header,
.dashboard .more, #homepage .box, .used-line #homepage .side_navigation ul.items-dropdown li.dropdown, ul.social_icon li, .dashboard .mask
{ transition: all 0.3s ease-in; -moz-transition: all 0.3s ease-in;-o-transition: all 0.3s ease-in;-webkit-transition: all 0.3s ease-in;-ms-transition: all 0.3s ease-in;}
/**========== Color ==========**/

.gray {color: #646464; }
.white {color:#fff; }
.black {color:#000; }
.blue {color:#007EE5 !important; }
.green {color:#028A00;}

.bg-gray {background-color: #44494F; }
.bg-white {background-color:#fff; }
.bg-black {background-color:#000; }
.bg-blue {background-color:#007EE5; }
.bg-green {background-color:#028a00;}
.bg-pink {background-color:#cc00c1;}
.bg-light-gray {background-color:#929292;}

.bg-class-0 {background-color: #cc00c1}
.bg-class-1 {background-color: #028a00}
.bg-class-2 {background-color: #FE7F00}
.bg-class-3 {background-color: #FF0000}
.bg-class-4 {background-color: #00BEFF}
/**========== Button ==========**/

.bt{
  display: table;
  height: 36px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 36px;
  border-radius: 3px;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.4);
  position: relative;
  padding: 0;
  -moz-transition: all 0.1s;
  -o-transition: all 0.1s;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.bt:hover{color: #fff;}
.bt.sm,
.button.sm{
  height: 28px;
  padding: 0 16px;
  line-height: 28px;
  border-radius: 14.5px;
  box-shadow: none;
  min-width: 72px;
}
.button.lg{
  height: 44px;
  line-height: 44px;
  padding: 0 45px;
}
.button.lg1{min-width: 170px;}
.bt img{
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 5px;
}
#top .btn-custom {
  width: 320px;
  margin: 20px auto 134px;
}
.btn-group .button.border{
  margin: 0 30px 0 0;
  background: #007EE5;
}
.btn-group .button.save{
  box-shadow: none;
  color: #646464;
  background: none !important;
  text-align: right;
  padding: 2px 0 0;
  cursor: text;
}
.btn-group .button.save .anim{display: none}
.btn-group .button .fa-check{display: none;}
.btn-group .button.save .fa-check{
  display: inline-block;
  vertical-align: middle;
  color: #646464;
  font-size: 14px;
  line-height: 14px;
  margin: -3px 3px 0 0;
}
/*.btn-group.dropdown.save:after{
  position: absolute;
  top: 0;
  right: 117px;
  bottom: 0;
  width: 1px;
  height: 100%;
  content: '';
  background: #adadad;
}*/
.btn-group.dropdown.save .button.border {
  margin-right: 15px;
}
.btn-group.dropdown.save .section-divider {
  width: 15px;
  height: 36px;
  float: right;
  border-left: solid #adadad 1px;
}
.button.change{
  position: absolute;
  top:0;
  right:0;
  z-index: 100;
  box-shadow: none;
  padding: 0 30px;
  border-radius: 2px;
}
.button {
  text-align: center;
  overflow: hidden;
  z-index: 0;
  cursor: pointer;

  min-width: 103px;

  height: 36px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  border-radius: 3px;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.4);
  position: relative;
  padding: 0;
  -moz-transition: all 0.1s;
  -o-transition: all 0.1s;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.button.raised {
/*-moz-transition: all 0.1s;*/
/*-o-transition: all 0.1s;*/
/*-webkit-transition: all 0.1s;*/
/*transition: all 0.1s;*/

}
.anim {
  -moz-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: -1;
}
.anim:before {
  position: relative;
  content: '';
  display: block;
  margin-top: 100%;
}
.anim:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
}

.hoverable{overflow: hidden}

.clickable .toggle:checked + .anim {
  -moz-animation: anim-in 0.75s;
  -webkit-animation: anim-in 0.75s;
  animation: anim-in 0.75s;
}
.clickable .toggle:checked + .anim:after {
  -moz-animation: anim-in-pseudo 0.75s;
  -webkit-animation: anim-in-pseudo 0.75s;
  animation: anim-in-pseudo 0.75s;
}
.clickable .toggle:not(:checked) + .anim {
  -moz-animation: anim-out 0.75s;
  -webkit-animation: anim-out 0.75s;
  animation: anim-out 0.75s;
}
.clickable .toggle:not(:checked) + .anim:after {
  -moz-animation: anim-out-pseudo 0.75s;
  -webkit-animation: anim-out-pseudo 0.75s;
  animation: anim-out-pseudo 0.75s;
}

.hoverable:hover > .anim {
  -moz-animation: anim-out 0.75s;
  -webkit-animation: anim-out 0.75s;
  animation: anim-out 0.75s;
}
.hoverable:hover > .anim:after {
  -moz-animation: anim-out-pseudo 0.75s;
  -webkit-animation: anim-out-pseudo 0.75s;
  animation: anim-out-pseudo 0.75s;
}

@-webkit-keyframes anim-in {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-moz-keyframes anim-in {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-ms-keyframes anim-in {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@keyframes anim-in {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-webkit-keyframes anim-in-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@-moz-keyframes anim-in-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@-ms-keyframes anim-in-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@keyframes anim-in-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@-webkit-keyframes anim-out {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-moz-keyframes anim-out {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-ms-keyframes anim-out {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@keyframes anim-out {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
@-webkit-keyframes anim-out-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@-moz-keyframes anim-out-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@-ms-keyframes anim-out-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
@keyframes anim-out-pseudo {
  0% {
    background: rgba(0, 0, 0, 0.45);
  }
  100% {
    background: transparent;
  }
}
/**========== Line ==========**/
.main-line, hr {border-color: #DADADA!important}
hr {margin: 20px 0; border: 0; border-top: 1px solid ;}
/* ===================================/***
     Typography
/*** ===================================***/
h1,h2,h3,h4,h5,h6 { color:#000000;}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-weight:400 ;
  color: #646464;
}
/**========== Title ==========**/
h1 {font-size: 25px; line-height:28px; text-transform: uppercase; }
h1.light {font-weight: 300;}
h1.medium {}
h1.bold {}

h2 {font-size: 23px; line-height: 26px;}
h2.light {}
h2.medium {}
h2.bold {}

h3{
  font-size: 20px;
  line-height: 23px;
}
h3.light {}
h3.medium {}
h3.bold {}
h1,h2,h3,h4,h5,h6{}
/**========== Txt ==========**/
p, ul li, ul li a, span { line-height: inherit;}
p { line-height: 20px; font-size: 16px;}
span { line-height: 17px; font-size: 12px;}

/**========== Link ==========**/
a {color: #000; text-decoration: none; cursor: pointer; font-size: 16px;}
/*a:focus{color: #fff;}*/
a.active, a.active:hover {text-decoration: none; color: #000;}
a:hover, a:focus{ text-decoration:none; outline:none; color: #000; }
a img{border: none;}
/**========== List ==========**/
ul, ol {  padding: 0; margin: 0; list-style:none;}
ul ul,
ul ol,
ol ol,
ol ul {margin-bottom: 10px;}
/**========== Fa icon ==========**/
.fa {margin-left: 5px;}
/*** ===================================/***
     Forms
/*** ===================================***/
input[type="text"],
input[type="password"],
input[type="datetime"],
input[type="datetime-local"],
input[type="date"],
input[type="time"],
input[type="number"],
input[type="email"],
input[type="url"],
input[type="search"],
input[type="tel"],
input[type="color"],
input[type="submit"],
select,
textarea,
.form-control
{

  height: 36px;
  border-radius: 2px 0 0 2px;
  border: solid 1px #c8c8c8;
  background-color: #ffffff;
  margin: 0;
  color: #000;
  font-weight: 400;
  box-shadow:none;
  padding: 5px 5px;
  font-size: 18px;
  line-height: 21px;
  outline: none;
  width: 100%;

}
textarea{
  resize: none;
  min-height:50px;
}
/*.form-control:focus {*/
/*border-color: #dcdcdc;*/
/*outline: 0;*/
/*box-shadow: none;*/
/*}*/

.form-group>.form-control {margin-bottom: 0px;}
.search-form .form-control{
  width: 450px;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
}
.homepage .search-form .form-control{
  width: 490px;
  height: 45px;
  border-radius: 4px 0 0 4px;
  background-color: #ffffff;
  border: solid 1px #c8c8c8;
}
.homepage .bt{
  width: 55px;
  height: 45px;
  border-radius: 0 4px 4px 0;
  background-color: #007ee5;
  border: solid 1px #007ee5;
}
::-webkit-input-placeholder {color: #000 !important;}
:-moz-placeholder {/* Firefox 18- */ color: #000 !important;}
::-moz-placeholder {  /* Firefox 19+ */color: #000 !important;}
:-ms-input-placeholder {color: #000 !important;}

input.has-icon, select.has-icon , textarea.has-icon { padding-left: 35px;}
/*** ===================================/***
     UI Elements
/*** ===================================***/
/**========== Popup/Notification ==========**/
.popup, .notification {border-radius:3px; box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.3); border: solid 1px #DADADA;}
.notification {
  position: fixed;
  top: 10px;
  right: 10px;
  width: 329px;
  height: 100px;
  border-radius: 3px;
  background-color: #ff7f00;
  z-index: 9999;
  box-shadow: 2px 2px 20px 0 rgba(0, 0, 0, 0.3);
  border:0;
}
.notification.white{
  background-color: #fff;
  top:120px;
}
.notification.white .img-box{
  background-color: #ff7f00;
}
.img-box{
  width: 94px;
  height: 100px;
  border-radius:4px 0 0 4px;
  padding: 31px 0 0;
  background-color: rgba(255, 255, 255, 0.3);
}
.img-box img{
  display: block;
  margin: 0 auto;
}
.txt-box{
  overflow: hidden;
  padding: 30px 9px 0;
}
.txt-box p{margin: 0 0 5px;}
.txt-box h3{margin: 0;}
.cross{
  position: absolute;
  top:7px;
  left: 5px;
  text-decoration: none;
  z-index: 99999;
}

/**========== Search ==========**/
/**========== Icon ==========**/
.i-doc {float:right; line-height:25px; cursor: pointer;}
/*Dicta Classic*/
/*Dicta Classic*/
/*Dicta Classic*/
/*Dicta Classic*/

.inner-header.experiment{
  padding: 11px 0;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
}
.inner-header .bt {
  position: absolute;
  top: 1px;
  right:15px;
  z-index: 100;
  width: 50px;
  height: 40px;
  border-radius: 0 2px 2px 0;
  background-color: #fff;
  box-shadow: none;
  border: 0;
  outline:none;
}
.search img{
  display: block;
  margin: 0 auto;
}
.main-navigation{
  display: block;
  text-align: right;
  margin: 0;
  padding: 19px 0;
  list-style: none;
}
.main-navigation li{
  display: inline-block;
  vertical-align: middle;
  margin: 0;
}
.experiment .main-navigation li a:focus,
.experiment .main-navigation li a:hover {
  color: #fff;
}
.main-navigation.add{padding: 0;}
.main-navigation.add li{
  margin: 0 0 0 20px;
  float: right;
}
.main-navigation li .btn-header{
  line-height: 36px;
  font-weight: 500;
}
a.active, a.active:hover {
  text-decoration: none;
}
.btn-header {
  margin-top: 3px;
  float: right;
  border-radius: 2px;
  background-color: #007ee5;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #ffffff;
}
.btn-header:focus,
.btn-header:hover{
  color: #fff;
}
.create {border: solid 1px #007ee5;}
.frame-box .btn-group{
  width: 100%;
}

.logo a{
  display: block;
  height: 100%;
}

::-webkit-input-placeholder {color: #bababa !important;}
:-moz-placeholder {/* Firefox 18- */ color: #bababa !important;}
::-moz-placeholder {  /* Firefox 19+ */color: #bababa !important;}
:-ms-input-placeholder {color: #bababa !important;}
#top {
  background: #fff;
  margin: 0;
  overflow: hidden;
  /*height: 66%;*/
  position: relative;
}
.inner{
  /*position: absolute;*/
  /*top: 46.5%;*/
  /*transform: translateY(-50%);*/
  /*left: 0;*/
  /*right: 0;*/
  text-align: center;
}
/*.container {*/
/*display: block;*/
/*overflow: hidden;*/
/*}*/
#top .containerbox {
  width: 425px;
  margin: 0 auto;
  padding: 150px 0 0;
}
.inner .logo{
  margin: 0 auto 52px;
}
.logo img{
  height: 40px;
  display: block;
}
 .logo.logo-homepage img{
  height: auto;
  display: block;
  width: 100%
}
/*
#bottom {
  position: absolute;
  left:0;
  right:0;
  bottom:0;
  padding: 55px 0 55px;
  min-height: ;
  height: 312px;
  background-color: #f6f8f9;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  border-bottom:8px solid #007ee5;
  text-align: center;
}
*/
#bottom {
  position: relative;
  width: 100%;
  float: right;
  padding: 55px 0 55px;
  background-color: #f6f8f9;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom:8px solid #007ee5;
  text-align: center;
}

#bottom .link-use{
  display: inline-block;
  vertical-align: top;
  text-decoration: underline;
  margin: 0 0 50px;
}
#bottom .link-use:hover{text-decoration: none;}
#bottom .link-use:hover{text-decoration: none;}
.img-frame {
  text-align: center;
}
.img-frame img{
  display: block;
  margin: 0 auto 30px;
}
.img-frame p{
  margin: 0;
}
.show-grid>[class^=col-]{
  position: relative;
}
.show-grid>[class^=col-]:after {
  width: 28px;
  height: 1px;
  z-index: 9999;
  position: absolute;
  top:23px;
  left: -14px;
  content: '';
  background: url("assets/Line.png") no-repeat;
}
.show-grid>[class^=col-]:first-child:after{
  background: none;
  display: none;
}

.icon-container {
  display: block;
  margin: 0 auto;
  max-width: 60px;
  min-height: 80px;
  margin-bottom: 16px;
}
.block-content p {
  text-align: center;
}
@media screen and (max-height: 815px){
  #top .containerbox {
    padding: 110px 0;
  }
}
@media screen and (max-height: 780px) {
  /*body{overflow-y: scroll;}*/

  #bottom{
    position: static;
    height: auto;
  }
  /*#top{height: inherit;}*/
  #top .containerbox{padding: 50px 0 50px 0;}
  #top .containerbox .btn-custom{
    margin: 20px auto 40px;
  }
  .inner {
    position: static;
    top: auto;
    transform: initial;
    left: auto;
    right: auto;
  }
  #home {
    height: inherit !important;
  }
}

@media screen and (max-width:786px){
  .wrapper{height: inherit;}
  .inner{
    width: 100%;
    position: static;
    transform:translateY(0);
  }
  #bottom{
    position: static;
    padding: 40px 0;
    height: auto;
  }
  .show-grid>[class^=col-]:after {
    width: 28px;
    height: 1px;
    z-index: 9999;
    position: absolute;
    top:-14px;
    left: 50%;
    margin: 0 0 0 -14px;
    content: '';
    background: url("assets/Line.png") no-repeat;
  }
  #top .containerbox {
    width: 100%;
    padding: 30px 15px 0;
  }
  #top .containerbox .btn-custom{
    margin: 20px auto 40px;
  }
  #top{
    height: auto;
  }
  .top-header{padding: 9px 15px;}
  .inner-header{padding: 14px 15px;}
}
/*Bible Classic*/
/*Bible Classic*/
/*Bible Classic*/
/*Bible Classic*/
/*Bible Classic*/
.wrapper {
  min-height: 100%;
}
@media (min-width: 1400px){
  .container {
    width: 1400px;
  }
}
/* newpage style start */
.main-contant{
  padding: 0;
  margin-bottom: 40px;
}
.frame-box{
  padding: 24px 0 26px;
}
.frame-box:after{
  content: '';
  display: block;
  clear: both;
}
.experiment-link{
  display: inline-block;
  vertical-align: top;
  padding: 0 36px 0 0;
  position: relative;
  cursor: pointer;
}
.experiment-link:after{
  position: absolute;
  top:4px;
  right:0;
  content: '';
  width: 19px;
  height: 19px;
  background: url("assets/ic_edit.png") no-repeat;
}
.field-holder{
  overflow: hidden;
  display: none;
  position: relative;
}
.frame-box.active .experiment-link{display: none;}
.frame-box.active .field-holder{display: block;}
.field-holder .form-control{
  padding: 5px 44px 5px 10px;
}
.field-holder .ok-icon{
  width: 30px;
  height: 30px;
  position: absolute;
  top: 3px;
  right: 4px;
  margin: 0;
  z-index: 9999;
  background: none;
  border-radius: 50%;
}
.field-holder .ok-icon:hover{background: #e0e0e0;}
.field-holder .ok-icon img{
  display: block;
  margin: 9px auto 0;
}
.main-contant .row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  /*flex-wrap: wrap;*/
  height: calc(100% - 75px);
}
.main-contant .row-eq-height .height {
  margin: 0 0 -10px;
  box-shadow: -1px 2px 5px 0 rgba(0, 0, 0, 0.3);
}
.main-contant .row-eq-height .height1{
  margin: 0 0 -10px;
  border-radius: 2px 2px 0 0;
  background-color: #ffffff;
  box-shadow: -1px 2px 4px 0 rgba(0, 0, 0, 0.3);
}
.row.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
}
#sidebar{
  overflow: hidden;
}
.heading-holder{
  overflow: hidden;
  padding: 27px 21px 19px;
  border-bottom: solid 1px #cdcdcd;
}

.img-txt{
  position: relative;
  margin: 0 0 30px;
}
.img-txt h2,
.img-txt h3,
.img-txt img{
  display: inline-block;
  vertical-align: bottom;
}
.img-txt img{margin: 0 8px 0 0;}
.img-txt h3{line-height: 17px;}
.noselection{margin: 0 0 13px;}
.main-list{
  overflow: hidden;
}
.main-list li{
  padding: 42px 25px 45px;
  border-bottom: 1px solid #cdcdcd;;
}
.main-list li ul li{
  border:none;
  padding: 0 0 13px 39px;
  position: relative;
}
#sidebar .main-list li ul li .bg-class {
  width: 29px;
  height: 20px;
  position: absolute;
  top:0;
  left: 0;
  content: "";
  border-radius: 1px;
}
.main-list li ul li p{
  margin: 0;
}
.main-list li ul.nocolor li{padding: 0 0 13px;}
.main-list li ul.nocolor li:before{display: none;}

#contant:after{
  content: "";
  display: block;
  clear: both;
}
.nav-tabs.analysis{
  padding: 26px 36px 0;
  border: none;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.15);
}
.nav-tabs.analysis li{
  padding: 0 15px;
  float: left;
}
.nav-tabs.analysis li a{
  margin: 0 !important;
  padding: 0 0 17px!important;

  transition: all .4s linear;
  border: none !important;
  border-bottom: 3px solid transparent !important;
}
.nav-tabs.analysis li.active a, .nav-tabs.analysis li a:hover {
  background-color: #fff!important;
  border-color: #646464 !important;
}
.tab-content1 {
  padding: 50px 51px;
  overflow: hidden;
}
.tab-content1 h3, .tab-content1 h3 span {
  margin: 0 0 15px;
  font-size: 20px;
  line-height: 24px;
  color: #646464;
  font-weight: 400;
}
.btn-group.open .dropdown-toggle,
.btn-group .dropdown-toggle:focus,
.btn-group .dropdown-toggle:active{
  color: #fff;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.4);
}
.dropdown-menu.box{
  padding: 0;
  margin: 12px 0 0;
  border-radius: 0;
  right: 0;
  width: 382px;
  height: 513px;
  font-size: 16px;
  line-height: 20px;
  background-color: #ffffff;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
  border:1px solid #cdcdcd;
  z-index: 99999;
}

/*.dropdown-menu.box:after, .dropdown-menu.box:before {*/
  /*bottom: 100%;*/
  /*right: 10%;*/
  /*border: solid transparent;*/
  /*content: " ";*/
  /*height: 0;*/
  /*width: 0;*/
  /*position: absolute;*/
  /*pointer-events: none;*/
  /*z-index: 100;*/
/*}*/

/*.dropdown-menu.box:after {*/
  /*border-color: rgba(246,246,246, 0);*/
  /*border-bottom-color: #f6f6f6;*/
  /*border-width: 12px;*/
  /*margin-left: -12px;*/
/*}*/
/*.dropdown-menu.box:before {*/
  /*border-color: rgba(63, 63, 68, 0.05);*/
  /*border-bottom-color: #4c4c4c;*/
  /*border-width: 12px;*/
  /*margin-left: -12px;*/
/*}*/
.add-header{
  overflow: hidden;
  padding: 14px 15px;
  border-radius: 1px;
  position: relative;
  z-index:100;
  background-color: #f6f6f6;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.48);
}
.add-header h3{margin: 3px 0 0;}
.inner-txt{
  padding: 20px 20px 20px 14px;
  overflow: hidden;
}
.inner-txt h3{
  margin: 0 0 20px;
}
.inner-txt p{margin: 0 0 15px;}
.inner-txt p a{
  padding:  0 0 1px;
  border-bottom: solid 1px #007ee5;
}
.inner-txt .list li:first-child{
  padding: 0 0 17px;
}
.inner-txt .list li .bt{margin: 0;}
.inner-txt .list li{
  height: inherit;
  padding: 28px 0 17px;
  border-bottom: solid 1px #dedede;
}
.inner-txt .list li .txtwrap{
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width:354px;
}
.inner-txt .list li .date{
  font-size: 14px;
  margin: 0 0 14px;
  display: block;
}
.inner-txt .link{
  color: #656565;
  margin: 5px 0 0 12px;
  box-shadow: none;
  min-width: inherit;
  padding: 0;
  height: auto;
  line-height: 20px;
  text-decoration: underline;
}
.maintxt{
  padding: 21px;
  overflow: hidden;
  border-radius: 3px;
  background-color: #f6f6f6;
  color: #646464;
  margin: 0 0 39px;
}
.heading-title {
  margin: 0 0 5px;
  text-transform: inherit;
}
.maintxt p{margin: 0;}
.maintxt .link{
  display: inline-block;
  vertical-align: middle;
  text-decoration: underline;
  margin: -2px 0 0 10px;
}
.heading-area{
  margin: 0 0 40px;
}
.heading-area .btn-group.dropdown{margin: -25px 0 0;}
.custom-link{
  font-size: 17px;
  line-height: 20px;
  text-decoration: underline;
  position: relative;
  padding: 0 0 0 25px;
  margin: 4px 0 0;
}
.custom-link:before{
  position: absolute;
  top: 2px;
  left: 0;
  content: '';
  width: 17px;
  height: 17px;
  background: url(assets/outline1.png) no-repeat;
}
.tab-content1 .new-list p {
  margin: 0 0 24px;
  padding: 2px 0 0 40px;
  position: relative;
}
.tab-content1 .new-list p .bg-class {
  width: 29px;
  height: 20px;
  border-radius: 1px;
  position: absolute;
  top:0;
  left: 0;
}
.tab-content1 .new-list .new-para{
  margin: 0;
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  letter-spacing: 0.2px;
  color: #797979;
}
.tab-content1 .new-list .new-para:hover{text-decoration: underline;}
.tab-content1 .new-list .new-para:before{display: none;}
.new-list ul{
  padding: 0 0 26px;
}
.new-list:after,
.new-list ul:after{
  display: block;
  content: "";
  clear: both;
}
.new-list ul li {
  float: left;
  margin: 0 17px 17px 0;
}
.new-list ul li a{
  height: 38px;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 2px 2px 2px 0 #cccccc, 0 0 0 1px rgba(63, 63, 68, 0.03);
  line-height: 36px;
  text-align: center;
  display: block;
  padding: 0 10px;
  border: 1px solid #dedede;
}
.heading-area .graphimg{
  width: 100%;
  height: auto;
  display: block;
  margin: 20px 0 0;
}
.heading-area .dropdown-toggle{
  display: inline-block;
  vertical-align: middle;
  padding: 0 9px;
  height: 28px;
  color: #646464;
  font-size: 14px;
  line-height: 28px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #999999;
}
.heading-area .dropdown-toggle:active,
.heading-area .dropdown-toggle:focus{
  color: #646464;
  box-shadow: none !important;
}
.heading-area .title{
  display: inline-block;
  vertical-align: middle;
  margin: 4px 5px 0 0;
}
.heading-area .dropdown-menu{
  padding: 0;
  top:0;
  margin: 0;
}
.heading-area .dropdown-menu li a{
  padding: 5px 15px;
}
.heading-area.margin{margin: 0 0 14px;}
.text{
  overflow: hidden;
  padding: 18px 27px 0;
  border-radius: 3px;
  background-color: #f6f6f6;
  position: relative;
}
.text .bg-class,
.text .bg-pink,
.text .bg-green{
  width: 17px;
  height: 100%;
  position: absolute;
  top:0;
  left: 0;
  bottom: 0;
}
.text p{
  margin: 0 0 15px;
}
.text .pull-right{
  text-decoration: underline;
}

.md-select {
  min-width: 180px;
  display: inline-block;
  vertical-align: middle;
  height: 28px;
  color: #646464;
  font-size: 14px;
  line-height: 28px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #999999;
  position: relative;
}
.md-select.active{border-color: transparent;}
.md-select *, .md-select :after, .md-select :before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-select label{margin: 0;}
.md-select [type=button] {

  cursor: default;
  display: block;
  position: relative;
  text-align: left;
  text-shadow: none;
  z-index: 1;
  outline: none;
  overflow: hidden;
  padding: 0 9px;
  height: 26px;
  color: #646464;
  font-size: 14px;
  line-height: 28px;
  border-radius: 3px;
  background-color: #ffffff;
  border: none;
  font-weight: 400;
  width: 190px;
  box-shadow: none;
}

.md-select [type=button]:after {
  content: '';
  width: 10px;
  height: 6px;
  float: right;
  margin: 12px 0 0 5px;
  background: url("assets/ic_down-black.png") no-repeat;
}
.md-select ul[role=listbox] {
  background-color: white;
  cursor: default;
  list-style: none;
  line-height: 26px;
  overflow: hidden;
  margin: 0;
  max-height: 0;
  position: absolute;
  top:0;
  right:0;
  padding: 0;
  /*-webkit-transform: translateY(-50%);*/
  /*transform: translateY(-50%);*/
  -webkit-transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
  width: 100%;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
}
.md-select ul[role=listbox] li {
  margin: 0;
  padding: 5px 15px;
  outline: none;
  overflow: hidden;
}
.md-select ul[role=listbox] li:focus, .md-select ul[role=listbox] li:hover, .md-select ul[role=listbox] li.active {
  background: rgba(0, 0, 0, 0.1);
}
.md-select.active ul {
  max-height: 200px;
  padding: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  z-index: 999999;
}
.txtblock{
  overflow: hidden;
  direction: rtl;
  border-radius: 3px;
  background-color: #fcfcfc;
  border: solid 1px #f6f6f6;
  margin: 1px 0 42px;
  padding: 13px 21px;
}
.opentxt{
  display: block;
  font-size: 14px;
  line-height: 17px;
  padding: 0;
  margin: 2px 0 0;
  text-align: left;
  border: none;
  position: relative;
  transition: all 0.5s ease;
}
.opentxt:after{
  position: absolute;
  top: -4px;
  right: 0;
  content: '';
  width: 26px;
  height: 26px;
  background: #fcfcfc url(assets/ic_down01.png) no-repeat  50% 50%;
  border-radius: 50%;
  transition: all 1s;
  border: 5px solid transparent;
}
.opentxt:hover:after{
  border: 5px solid #d8d8d8;
  background: #d8d8d8 url(assets/ic_down01.png) no-repeat  50% 50%;
}
.txtblock.active .opentxt{
  margin: 2px 0 25px;
  padding: 0 0 8px;
  border-bottom: solid 1px #adadad;
}
.txtblock.active .opentxt:after{
  transform:rotate(90deg);
  top:-5px;
}
.slidetxt{
  overflow: hidden;
  display: none;
}
.slidetxt p{
  margin: 0 4% 0 0;
  padding: 0 6px;
}
.verses-list{
  overflow: hidden;
  padding: 0;
  margin: 0 0 25px;
}
.verses-list li{
  display: block;
  float: none;
  width: 100%;
  padding: 5px 9px;
  margin: 0 0 2px;
  overflow: hidden;
  border: none;
}
.verses-list li.active{background-color: #eff8ff;}
.verses-list li a{
  display: block;
  cursor: initial;
}
.verses-list li span{
  float: right;
  font-size: 18px;
  line-height: 30px;
  width: 96%;
}
.verses-list li .first-word{
  padding: 0 0 0 15px;
  font-size: 14px;
  line-height: 21px;
  font-family: 'Arimo';
  width: 4%;
  float: right;
  font-style: normal;
}
.chart-holder{
  overflow: hidden;
}
.chartBarsWrap {
  margin: 40px 0 25px;
}
.chartBars {
  position: relative;
  max-width: 100%;
  height: 180px;
  padding: 0 0 0 60px;
}
.chartBars .bars {
  display: -webkit-box;
  display: -ms-flexbox;
  white-space: nowrap;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  border-left: 1px solid #bbb;
  border-bottom: 1px solid #bbb;
  width: 100%;
  height: 205px;
  padding: 0 1%;
  margin: 0;
  overflow-x: auto
}
.chartBars .bars li {
  display: inline-block;
  height: 180px;
  margin: 0 0 0 10px;
  text-align: center;
  position: relative;
  font-size: 16px;
  width: 11px;
}
.chartBars .bars li .bar {
  position: absolute;
  font-size: 1.5em;
  color: #fff;
  padding-top: 18px;
  bottom: 0px;
  height: 0;
  overflow: hidden;
  font-weight: bold;
  outline: 2px solid transparent;
  -webkit-transition: 1.5s height cubic-bezier(0.6, 0.4, 0.4, 1.1);
  transition: 1.5s height cubic-bezier(0.6, 0.4, 0.4, 1.1);
  width: 11px;
  border-radius: 0;
  background-color: #028a00;
}
.chartBars .bars li .bar:after {
  content: '%';
  font-size: 22px !important;
  vertical-align: top;
  color: rgba(255, 255, 255, 0.8);
  margin-right: -8px;
}
.chartBars .bars li b {
  color: #646464;
  width: 100%;
  position: absolute;
  bottom: -2em;
  left: 0;
  text-align: center;
  font-size: 10px;
  line-height: 12px;
}
.chartBars .numbers {
  width: 50px;
  height: 110%;
  margin-left: 51px;
  padding: 0;
  display: inline-block;
  position: absolute;
  left: -5.25%;
  top:-10%;
}
.chartBars .numbers li {
  text-align: left;
  padding-right: 1em;
  list-style: none;
  height: 25px;
  position: absolute;
  font-size: 14px;
  bottom: 91%;
  left: 0;
  color: #646464;;
}
.chartBars .numbers li:after {
  content: "\00af";
  position: relative;
  right: -5px;
  font-size: 20px;
  top: 7px;
  color: rgba(255, 255, 255, 0.34);
}
.chartBars .numbers li:first-of-type {
  height: 17px;
  top: 0%;
}
.chartBars .numbers li.center{
  position: absolute;
  top: 46%;
  height: 17px;
}
.chartBars .numbers li.bottom{
  position: absolute;
  bottom: 0;
  height: 17px;
}
.chartBars .numbers li:after{
  width: 100vw;
  height: 1.5px;
  left: 0px;
  right: 0;
  top: 100%;
  position: absolute;
  background: #979797;
  z-index: 9999;
}

.chartBars3 {
  background: rgba(255, 255, 255, 0.1);
  border: 0 !important;
}
.chartBars3 .bars {
  border-color: #666;
  padding: 0;
  border: 0 !important;
}
.chartBars3 .bars li .bar {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  font-size: 0 !important;
}
.chartBars3 .bars li .bar:after {
  font-size: .6em !important;
}
.chartBarsWrap.chartBarsHorizontal {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 70px;
}
.chartBarsWrap.chartBarsHorizontal .bars b {
  color: #eee;
  width: 100%;
  position: absolute;
  bottom: initial;
  top: 1em;
  left: -102%;
  text-align: right;
}
.chartBarsWrap.chartBarsHorizontal .chartBars {
  height: 200px;
}
.chartBarsWrap.chartBarsHorizontal .chartBars .bars {
  border: 0;
}
.chartBarsWrap.chartBarsHorizontal .chartBars .bars .bar {
  width: 0;
  padding-top: 10px;
  height: 100% !important;
  text-align: right;
  font-size: 1.5em;
  -webkit-transition: 2s width cubic-bezier(0.6, 0.4, 0.4, 1.1);
  transition: 2s width cubic-bezier(0.6, 0.4, 0.4, 1.1);
}
.chartBarsWrap.chartBarsHorizontal .chartBars .bars .bar:after {
  font-size: .6em !important;
  margin-right: 20px;
}
.bars li .bar.class-1-bar,
.bars li .bar.greenBar {
  background-color: #028a00;}
.bars li .bar.class-0-bar,
.bars li .bar.purpleBar {
  background-color: #cc00c1;}
.bars li .bar.class-2-bar {
  background-color: #fe7f00;}
.bars li .bar.class-3-bar {
  background-color: #ff0000;}
.bars li .bar.class-4-bar {
  background-color: #00beff;
}
.box-piesite {
  text-align: center;
  font-size: 22px;
}
.piesite {
  position: relative;
  width: 1em;
  height: 1em;
  font-size: 10em;
  cursor: default;
}
.piesite .percent {
  position: absolute;
  top: 1.1em;
  left: .1em;
  width: 100%;
  font-size: .3em;
  text-align: center;
  z-index: 2;
}
.piesite .percent .symbol {
  font-size: .5em;
  vertical-align: top;
  opacity: .5;
}
.piesite > #slice {
  position: absolute;
  width: 1em;
  height: 1em;
  clip: rect(0px, 1em, 1em, 0.5em);
}
.piesite > #slice.gt50 {
  clip: rect(auto, auto, auto, auto);
}
.piesite > #slice > .pie {
  position: absolute;
  border: .1em solid #444;
  width: 1em;
  height: 1em;
  clip: rect(0em, 0.5em, 1em, 0em);
  border-radius: 0.5em;
}
li.design .piesite > #slice > .pie {
  border-color: #49E;
}
li.usability .piesite > #slice > .pie {
  border-color: #FFA500;
}
li.creativity .piesite > #slice > .pie {
  border-color: #6B8E23;
}
.piesite > #slice > .pie.fill {
  -webkit-transform: rotate(180deg) !important;
  transform: rotate(180deg) !important;
}
.piesite.fill > .percent {
  display: none;
}
.piesite:after {
  content: '';
  display: block;
  position: absolute;
  top: .1em;
  left: .1em;
  width: .8em;
  height: .8em;
  background: #30303A;
  border-radius: 100%;
  z-index: 1;
}
.piesite:before {
  content: '';
  display: block;
  position: absolute;
  width: 1em;
  height: 1em;
  border-radius: .5em;
  opacity: .5;
  z-index: 0;
}
.piesite:before {
  background: rgba(255, 255, 255, 0.1);
}
.box-piesite ul {
  padding: 0;
}
.box-piesite ul li {
  display: inline-block;
  margin: 10px 20px;
}
.chartBarsHorizontal .chartBars .bars {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.tooltip > .tooltipContent {
  display: block;
  position: absolute;
  background: none repeat scroll 0 0 #222;
  color: #F0B015;
  font-size: 0.8em;
  font-weight: normal;
  line-height: 1.5em;
  padding: 16px 15px;
  min-width: 200px;
  max-width: 500px;
  top: 0;
  left: 50%;
  -webkit-transform: translate(-50%, -110%);
  transform: translate(-50%, -110%);
  margin-left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  text-align: center;
  z-index: 2;
  text-transform: none;
  -webkit-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.tooltip:hover > .tooltipContent {
  opacity: 1;
  filter: alpha(opacity=100);
  z-index: 99;
  -webkit-transform: translate(-50%, -130%);
  transform: translate(-50%, -130%);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tooltip .tooltipContent:after {
  border-color: #222 rgba(0, 0, 0, 0);
  border-style: solid;
  border-width: 15px 15px 0;
  bottom: -15px;
  content: "";
  display: block;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  position: absolute;
  width: 0;
}
.arrow-holder{
  padding:5px 0 0 15px;
}
.arrow-holder .left{
  float: left;
}
.arrow-holder .right{
  float: right;
  background: #fff;
}
/***/
/***/
/***/
/***/
/*inner.css*/

/* Outer */
.popup-new {
  width:100%;
  height:100%;
  display:none;
  position:fixed;
  top:0px;
  left:0px;
  z-index: 999999;
  /*background:rgba(0,0,0,0.75);*/

}
.txt-box {
  overflow: hidden;
  padding: 17px 49px;
  margin-bottom: 25px;
  border-radius: 3px 3px 0 0;
  background-color: #007ee5;
}
.txt-box .img-txt{
  margin: 0;
}
.txt-box .img-txt span{
  color: #fff;
  font-size: 23px;
  line-height: 25px;
}
.txt-box .img-txt span strong{font-weight: 400;}

.classes-area{
  padding: 10px 0 20px;
  overflow: hidden;
  /*height: 610px;*/
  font-size: 20px;
  line-height: 23px;
  position: relative;
}
.classes-area.add{padding: 17px 49px 20px;}
.classes-area h3{margin: 0 0 27px;}
.edit-box .experiment-class h3{
  margin: 0;
  text-transform: capitalize;
}
.experiment-class{
  display: inline-block;
  vertical-align: top;
  padding: 0 30px 0 0;
  position: relative;
  text-transform: uppercase;
}
.experiment-class:after {
  position: absolute;
  top: 4px;
  right: 0;
  content: '';
  width: 14px;
  height: 15px;
  background: url(assets/ic_edit1.png) no-repeat;
}
.edit-box .field-holder,
.edit-box.active .tooltip-holder,
.edit-box.active .experiment-class{display: none;}
.edit-box.active .field-holder{display: block;}
.tooltip-holder {
  position: relative;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.tooltip-holder-img{
  display: block;
  margin: -2px 0 0;
}
.tooltip p{margin: 0;}
.tooltip {
  bottom: 33px;
  display: none;
  left: -14px;
  opacity: 1;
  position: absolute;
  z-index: 999;
  -webkit-transform: translateY(10px);
  -moz-transform: translateY(10px);
  -ms-transform: translateY(10px);
  -o-transform: translateY(10px);
  transform: translateY(10px);
  -webkit-transition: all 0.25s ease-out;
  -moz-transition: all 0.25s ease-out;
  -o-transition: all 0.25s ease-out;
  transition: all 0.25s ease-out;
  width: 245px;
  background-color: #ffffff;
  box-shadow: 3px -1px 4px 0 rgba(76, 76, 76, 0.46);
  border: solid 1px #c6c6c6;
  font-size: 16px;
  line-height: 20px;
  padding: 15px;
  border-radius: 3px;
  text-align: center;
}

.tooltip:after, .tooltip:before {
  top: 100%;
  left: 22px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.tooltip:after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}
.tooltip:before {
  border-color: rgba(231, 231, 231, 0);
  border-top-color: #8f8f8f;
  border-width: 11px;
  margin-left: -11px;
}

/*.tooltip-holder:hover .tooltip {*/
/*opacity: 1;*/

/*-webkit-transform: translateY(0px);*/
/*-moz-transform: translateY(0px);*/
/*-ms-transform: translateY(0px);*/
/*-o-transform: translateY(0px);*/
/*transform: translateY(0px);*/
/*display: block;*/
/*}*/
.tooltip a{
  border-bottom: solid 2px #007ee5;
}
#tooltip-close{left: -17px;}
.edit-box{margin: 0 0 10px;}
.textarea-holder{
  border-radius: 2px;
  background-color: #f5f5f5;
  position: relative;
  padding:  0 112px 0 0;
}
.selectedtxt{
  background: #f5f5f5;
  padding: 12px 10px 10px;
  border: solid 1px transparent;
  position: relative;
}
.selectedtxt:after{
  position: absolute;
  top:0;
  right:2px;
  bottom: 0;
  content: '';
  width: 1px;
  height: 100%;
  background: #dedede;
}
.selectedtxt.error{
  border-color: #ff0000;
  border-right: none;
}
.selectedtxt p{margin: 0;}

.experiment-text{
  border-color: #f5f5f5;
  border-style: solid;
}
.experiment-text.error{
  border-color: #ff0000;
}

.txt-frame{padding: 0 0 28px;}
.txt-frame:after{
  display: block;
  content: '';
  clear: both;
}
.addclass{
  padding: 0 0 0 20px;
  position: relative;
}
.addclass:before{
  position: absolute;
  top: 1px;
  left: 0;
  content: '';
  width: 14px;
  height: 14px;
  background: url(assets/plus.png) no-repeat;
}
.tooltip-holder.cross{
  position: absolute;
  left: -22px;
  top: 10px;
}
.tooltip-holder.cross img{margin: 8px 0 0;}
.tooltip-holder.cross .tooltip{text-align: center;}
.tooltip-holder.cross p{margin: 0 0 10px;}
.button-holder{
  overflow: hidden;
  padding: 0 0 5px;
}
.button-holder .bt{
  display: inline-block;
  vertical-align: middle;
  margin: 0 4px;
  min-width: 69px;
  border-radius: 3px;
}
.button-holder .bt:focus{color: #fff;}
.button-holder .bt.active{
  border: solid 1px #007ee5;
  text-decoration: none;
}
.button-holder .bt.active:hover{color: #007ee5;}
/* Inner */
.popup-new .popup-inner {
  padding:0;
  position:absolute;
  top:50%;
  left:50%;
  -webkit-transform:translate(-50%, -50%);
  transform:translate(-50%, -50%);
  z-index: 9999999;
  min-width: 318px;
  width: 980px;
  height: 85%;
  border: 0 !important;
  margin: 0;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 #4c4c4c, 0 0 0 1px rgba(63, 63, 68, 0.05);
}
.popup-close{
  position: absolute;
  top: -35px;
  left: 0;
  z-index: 99999;
}
.popup-close i{
  color: #fff;
  font-size: 25px;
  line-height: 25px;
  font-weight: 100;
}
.tile {
  height: 100%;
  overflow: hidden;
}
.tile .tab-content2 {
  height: 86%;
}
.text-selection-popup{
  z-index:99999999;
  height: 100%;
  padding: 0 0 0 56px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 3px;
}
.inner-below{
  position: relative;
  z-index: 9999999;
}
.nav-tabs {
  position:relative;
  border:none!important;
  background-color:#fff;
  text-align: center;
  box-shadow: none;
  border-bottom: 1px solid #C4CDD5 !important;
  overflow: hidden;
}
.nav-tabs li {
  margin:0;
  padding: 0;
  border: none;
  float: none;
  display: inline-block;
  vertical-align: middle;
}
.nav-tabs li a {
  position:relative;
  padding: 0 0 15px!important;
  font-size:14px;
  margin:0 8px !important;
  color:#646464;
  transition:all .4s linear;
  border: none !important;
  border-bottom:3px solid transparent !important;

}
.nav-tabs>li.active>a,
.nav-tabs a:hover {
  background-color:#fff!important;
  border-color: #646464 !important;
}
.control {
  display: block;
  padding-left: 0;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: #797979;
}
.control.control--radio > p,
.control.control--checkbox > p{
  overflow: hidden;
  margin:0;
  padding: 0 !important;
}
.chek-box-holder{
  width: 19px;
  float: left;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  display: inline-block;
  vertical-align: middle;
  margin: -3px 0 0 0;
  background: none;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  position: relative;

  background-color: #ffffff;
  border: solid 1px #adadad;
}
.selectall .control__indicator{border-color: #000;}
.control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator, .control input:indeterminate ~ .control__indicator{
  border-color: #007ee5;
  background-color: #007ee5 !important;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: -7px;
  width: 9px;
  height: 20px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control input:checked ~ .control__indicator {
  background: none;
}
.control--checkbox .control__indicator:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox.uncheck .control__indicator:after{
  width: 8px;
  height: 2px;
  left: 2.5px;
  top: 6.4px;
  transform: rotate(0deg);
  display: block;
}
.control-group.check li.active .control--checkbox .control__indicator:after{
  width: 8px;
  height: 8px;
  border-radius: 1px;
  background-color: #1c222d;
  box-shadow: 0 1px 1px 0 rgba(64, 82, 88, 0.03), 0 1px 1px 0 rgba(97, 121, 133, 0.05);
  border: solid 1px #848f99;
  left: 3px;
  top: 3px;
  transform: rotate(0deg);
}

.control--radio .control__indicator {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin: -5px 0 0 0;
  border: solid 1px #1c222d;
}
.control-group.check li .control.control--radio > p{
  margin: 0 0 0 34px;
}
.control--radio .control__indicator:after {
  left: 50%;
  top: 50%;
  height: 10px;
  width: 10px;
  margin: -5px 0 0 -5px;
  border-radius: 50%;
  background: #000;
}
.mynav{
  padding: 0;
  margin: 0;
  overflow: hidden;
  border-bottom: 1px solid #adadad !important;
}
.mynav li{
  float: left;
  padding: 15px 16px 13px;
  border-left: 1px solid #adadad;
}
.mynav li:first-child{
  border:0;
}
.mynav li:before{display: none;}
.mynav li a{
  color: #646464;
}
.mynav li ul{
  border: none;
}
.mynav li ul li a{
  color: #656565;
  font-size:14px;
  line-height: 17px;
  display: block;
}
.mynav li ul li:not(:last-child) a {
  text-decoration: underline;
}
.mynav li ul li{
  color: #929292;
  border: none !important;
  padding: 0 0 0 20px;
  position: relative;
}
.mynav li ul li:first-child:after{display: none;}
.mynav li ul li:first-child{
  padding: 0;
}
.mynav li ul li:after{
  content: "\f105";
  position: absolute;
  top: 0;
  left: 9px;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #646464;
  font-size: 16px;
}
.side{
  border-right: 1px solid #adadad;
}
#mypopup .side{
  border: none;
  padding-bottom: 10px;
}
#mypopup .side:after{
  width: 1px;
  height: 100vh;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  content: '';
  background: #adadad;
}
.row.no-gutters {
  margin-right: 0;
  margin-left: 0;
  position: relative;
}
.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
}
.control-group.check{
  padding: 25px 0;
  font-size: 17px;
  line-height: 20px;
  min-height: 492px;
  margin: 0;
}
#messages .control-group.check{line-height: 19px;}
.control-group.check li .control.control--checkbox > p{
  margin: 0 25px;
}
.control-group.check li{
  position: relative;
  padding: 13px 15px 14px;
  margin: 0;
  border: none !important;
}
.control-group.check .selectall:after{display: none;}
.control-group.check li .after{

  position: absolute;
  top: 0;
  right: 0;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #646464;
  font-size: 16px;
  width: 41px;
  height: 47px;
  line-height: 47px;
  cursor: pointer;
  text-align: center;
}
.control-group.check li .after:after{
  content: "\f0da";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #646464;
  font-size: 16px;
  width: 41px;
  height: 47px;
  line-height: 47px;
}
.control-group.check li:hover .control__indicator{
  border-color: #1c222d;
}
.control-group.check li:hover{
  background: #f6f8f9;
  /*background: #ccc;*/
}
.list li .control-group.check li:hover{background: inherit}
.control-group.check li:hover .after{
  background-color: #ebecec;
}
.frame{
  overflow: hidden;
  color: #646464;
  padding: 90px 25px 40px;
  text-align: center;
  line-height: 25px;
  font-size: 14px;
  min-height: 504px;
}
.img-holder{
  width: 54px;
  height: 58px;
  margin: 0 auto 20px;
  text-align: center;
  position: relative;
}
.img-holder img{
  display: block;
  width: 100%;
  height: auto;
}
.img-holder.second-img{
  width: 59px;
  height: 59px;
}
.img-holder .counter,
.img-holder .lowercase{
  display: none;
}
.img-holder.second-img .microscope,
.img-holder.second-img .counter,
.img-holder.second-img .lowercase{
  display: block;
}
.img-holder.second-img .counter{
  width: 26px;
  height: 26px;
  background-color: #c1c1c1;
  position: absolute;
  top: -13px;
  right: -11px;
  line-height: 26px;
  font-size: 17px;
  border-radius: 50%;
  color: #fff;
}
.frame p{
  margin: 0;
  opacity: 0.71;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display:         flex;
}
.tab-footer{
  border-top: 1px solid #979797;
  padding: 17px 13px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  background: #fff;
  border-radius: 0 0 3px 3px;
}
.error-tooltip{
  width: 208px;
  left: auto;
  bottom:60px;
}
.error-tooltip:after, .error-tooltip:before{
  left: 49%;
}
.tab-footer .txt-select{
  display: block;
  font-size: 14px;
  line-height: 17px;
  color: #929292;
  font-weight: 400;
  margin: 0 0 5px;
}
.tab-footer .txt-select.no-select{
  font-size: 17px;
  line-height: 20px;
  font-weight: 700;
  margin: 0;
}

.tab-footer .btn-save{width: 211px;}
.tab-footer .btn-save.active{
  cursor: inherit;
  opacity: 0.3;
}

.block{
  overflow: hidden;
  direction: rtl;
  padding: 12px 40px;
}
.block .verses-list li .first-word{width: 5%;}
.block .verses-list li span{width: 95%;}
.block ol{
  list-style: decimal;
  padding: 35px 125px 20px;
  text-align: right;
  counter-reset: li;
  font-size: 17px;
  line-height: 20px;
  color: #646464;
}
.block ol li{
  width: 100%;
  margin: 0 0 15px;
}
.add-txt{
  float: right;
  padding: 10px 20px 0;
}
.add-txt span{
  display: inline-block;
  vertical-align: middle;
  font-size: 17px;
  font-weight: 400;
  line-height: 20px;
  color: #b3b3b3;
  margin: -3px 0 0 3px;
}
.add-txt .link{
  display: inline-block;
  vertical-align: middle;
  font-size: 17px;
  font-weight: bold;
  line-height: 20px;
  color: #b3b3b3;
  text-decoration: none;
  border-bottom: solid 1px #979797;
  padding: 0 0 3px;
}
.new-nav{
  overflow: hidden;
  padding: 12px 0 0;
}
.new-nav li{
  display: inline-block;
  vertical-align: middle;
  padding: 0 30px 0 0;
}
.new-nav li a{
  display: block;
  font-size: 14px;
  line-height: 17px;
  color: #929292;
}
.control-group.check.save{
  padding: 0;
  min-height: inherit;
  margin: 0;
}
.control-group.check.save li{border: 0; padding: 0; margin: 0;}
.control-group.check.save li:before{display: none;}
.control-group.check.save li:after{display: none;}
.control-group.check.save li .control.control--checkbox > p {
  margin: 0 25px;
  color: #646464;
}
.list{
  overflow: hidden;
  min-height: 552px;
  padding: 0 14px;
}
.list li:first-child{
  margin: 0 -14px;
  padding: 22px 14px 15px;
  border-bottom: 2px solid #adadad;
}
.list li{
  height: 62px;
  padding: 22px 0 15px;
  border-bottom: solid 1px #dedede;
}
.list li p{margin: 0;}
.list li .bt{margin: -6px 0 0;}
.list li em{
  font-size: 14px;
  font-style: italic;
  line-height: 17px;
  color: #646464;
}
.add-link.add{
  width: 81px;
}
.mytitle {
  font-size: 17px;
  line-height: 17px;
  color: #646464;
  display: block;
}
.back-arrow{
  overflow: hidden;
  width: 56px;
  height: 100%;
  border-radius: 3px 0 0 3px;
  background-color: #e0e0e0;
  position: absolute;
  left: 0;
  top:0;
  bottom: 0;
  padding: 10px 8px;
  z-index: 105;
}
.text-selection-popup .popup-inner{padding: 0 0 0 56px;}
.text-selection-popup .tab-footer{
  left: 56px;
  border: none;
  background-color: #f6f6f6;
}
.footer-txt{
  overflow: hidden;
  padding: 0 21px 0 2px;
}
.tab-footer .button.lg{min-width: 211px;}
.footer-txt p{
  margin: 0;
  font-size: 17px;
}
.popup-new .nav-tabs{
  height: 50px;
  padding: 19px 0 0;
  border-radius: 0 3px 0 0;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.popup-new .nav-tabs.addstyle li a{padding: 0 0 4px!important;}
.popup-new .nav-tabs li a{
  padding: 0 0 3px!important;
  height: auto !important;
}
.popup-new .nav-tabs li a:hover{
  background-color: #fff!important;
  border-color: #646464 !important;
}
.popup-new table {
  border: none;
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 30px;
}
.popup-new #scrollable266 table {margin-bottom: 200px;}
.tabel-box{
  position: relative;
  padding: 50px 0 0;
}
.popup-new .tabel-box table{
  margin: 0;
  table-layout: auto;
}
.popup-new table .tabel-header{
  position: fixed;
  top:87px;
  left: 0;
  right:0;
  z-index: 999;
  background: #fff;
}
.fixed{
  position: fixed;
  top: 74px;
  left: 0;
  right: 0;
  background: #fff;
}
.popup-new .showHideMessage{
  margin: 0;
}
.popup-new .showHideMessage tr,
.popup-new .fixed tr{
  border-bottom: solid 1px #adadad !important;
}
.showHideMessage .button{
  width: 79px;
  min-width: 79px;
  height: 28px;
  color: #000;
  box-shadow: none;
  line-height: 28px;
  border-radius: 2px;
  margin: -15px 0 0;
  background-color: #e0e0e0;
}
.showHideMessage .button img{
  display: inline-block;
  vertical-align: middle;
  margin: -1px 0 0 0;
}
#mypopup-classification table tr td,
.popup-new .fixed tr td{
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  padding: 16px 40px 12px !important;
}
#mypopup-classification .showHideMessage tr td{
  text-align: left;
  padding: 0 40px !important;
}
.popup-new .fixed thead tr td{
  font-weight: 700;
}
.popup-new .fixed thead tr td h3{
  text-align: left;
}
.popup-new table .tabel-header tr{display: block;}
.popup-new table th,
.popup-new table td {
  padding: 16px 20px 12px;
  width: 18%;
  text-align: center;
}
.popup-new table th {
  font-size: 14px;
  font-weight: 700;
  padding: 0 12px 21px;
}
.popup-new table .col{
  width: 64%;
  text-align: left;
}
.popup-new table tbody tr:nth-child(even){background-color: #f9f9f9;}
#messages,
#profile{height: 552px;}
.text-frame{
  overflow: hidden;
  padding: 73px 40px;
  text-align: center;
}
.text-frame h3 a{
  font-size: 20px;
  padding: 0 0 4px;
  border-bottom: solid 2px #007ee5;
}
/* features-classes popup style */
#remove_words_features_popup .txt-box{margin: 0;}
.popup-holder{
  overflow: hidden;
  position: relative;
}
.nav-link{
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  text-align: center;
}
.nav-link li{
  display: inline-block;
  vertical-align: middle;
  padding: 0 20px;
  margin: 0 !important;
  float: none !important;
}
.nav-link.checktab li{padding: 0 10px;}
.nav-link li a{
  box-shadow: none !important;
  display: block;
  padding: 0 0 8px;
  border-bottom: solid 3px transparent;
}
.nav-link li.active a{border-bottom: solid 3px #646464;}

.nav-link li .control__indicator{
  margin: 0;
  line-height: 23px !important;
}
.features .chek-box-holder{
  width: 16px;
  line-height: 23px !important;
}
.features .category-header-row .chek-box-holder{
  display: inline-block;
  vertical-align: middle;
}
.category-header-row .checkbox-div{
  width: auto !important;
}
.category-header-row {
  border-bottom: ridge 2px #adadad;
  border-top: ridge 2px #adadad;
  background-color: #f9f9f9 !important;
}
.features .addstyle .chek-box-holder{width: 25px;}
.chek-box-holder{}
.features table .col {
  width: 31%;
  text-align: left;
}
.features table .col2{width: 23%;}
.add-progressBar {
  overflow: hidden;
  width: 100%;
  height: 24px;
  border-radius: 2px;
  background-color: #d8d8d8;
}
.add-progressBar div {
  height: 100%;
  color: #fff;
  text-align: right;
  line-height: 11px;
  width: 0;
  text-indent: 9999px;
  overflow: hidden;
  border-radius: 2px;
  background-color: #727272;
}
.features .tab-footer{overflow: hidden;}
.features table tbody tr:nth-child(even){background: none;}
.features table tbody tr:nth-child(odd) {background-color: #f9f9f9;}
.features table th, .features table td{
  padding: 8px 25px 6px;
  text-align: left;
}
.features .addstyle th{
  border: none;
}
.features table th p{
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
}
.features table th p:before{display: none !important;}
.btn-vertical{
  width: 10px;
  float: right;
  margin: 16px 0 0;
}
.btn-vertical a{
  box-shadow: none;
  padding: 0;
  display: block;
  line-height: 12px;
}
/*.btn-vertical a:hover{opacity: 0.54;}*/
.btn-vertical a i{
  margin: 0;
  line-height: 7px;
}
.tab-content1 .new-list .addstyle p{
  margin: 0 !important;
  padding: 0 0 0 24px !important;
}
.tab-content1 .new-list .addstyle .col .new-para,
.tab-content1 .new-list .addstyle .col .feature-div p{padding: 0 !important;}
.control.control--radio > p:before, .control.control--checkbox > p:before{
  display: none;
}
.tab-content1 .new-list .addstyle .bg-class{
  width: 19px;
  height: 11px;
  top: 4px;
}
.bt.lg img{
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px;
}
/* classes-information style */
.features table .col3{width: 10%;}
.view-chart:hover,
.view-chart{text-decoration: underline;}
.chart .tooltip{
  top: 100%;
  bottom: auto;
  left: auto;
  right: -12px;
  width: 286px;
  height: 197px;
  padding: 14px;
  text-align: left;
  text-decoration: none;
}
.chart .tooltip:hover p{text-decoration: none !important;}
.chart .tooltip:after, .chart .tooltip:before {
  top: auto;
  bottom: 100%;
  right: 26px;
  left: auto;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.chart .tooltip:before {
  border-color: rgba(231, 231, 231, 0);
  border-bottom-color: #8f8f8f;
  border-width: 11px;
  margin-right: -11px;
}
.chart .tooltip:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-right: -10px;
}
.tooltip .cancel{
  float: right;
  border: none;
  margin: 7px 0 0;
}
.line-txt{
  width: 100%;
  height: 19px;
  position: relative;
  margin: 24px 0 30px;
  border-bottom: solid 1px #747474;
}
.line-txt:before,
.line-txt:after{
  width: 1px;
  height: 14px;
  position: absolute;
  left: 0;
  top:11px;
  bottom: 0;
  content: '';
  background: #979797;

}
.line-txt:after{
  left: auto;
  right:0;
}
.tooltip .line-txt a{border: none;}
.tooltip .triangle{
  position: absolute;
  top:10px;
  left: 10%;
  width: 20px;
  height: 19px;
}
.tooltip .triangle img{display: block;}
.blackbox,
.greenbox{
  position: absolute;
  left: 40%;
  top:10px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-indent: -9999px;
  overflow: hidden;
}
.blackbox{
  left: 80%;
}
.description{overflow: hidden;}
.description p{
  margin: 0 0 7px;
  padding: 0 0 0 25px;
  position: relative;
}
.description .test-info:before{
  width: 21px;
  height: 19px;
  content: '';
  position: absolute;
  top:0;
  left: 0;
  background: url("assets/Triangle.png") no-repeat;
}
.description .other-info .bg-black,
.description .winning-info .bg-green{
  position: absolute;
  left: 0;
  top:0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
/*.description .other-info.black-bg:before{background-color: #000;}*/
#view_advanced_information .txt-box{margin: 0;}
#view_advanced_information .text{
  background-color: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.27);
  border-radius: 0;
  padding: 13px 27px 4px;
}
#view_advanced_information .text p{margin:0 0 5px}
/* verses-popup style */
.header-area{
  padding: 15px 20px 12px;
  border-radius: 3px 3px 0 0;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.header-area h3{margin: 0 !important; line-height: 23px;}
#verses-popup .back-arrow {
  display: none;
}
.block-list{
  overflow: hidden;
  margin: 0 !important;
  padding: 13px 0 !important;
}
.block-list li{
  margin: 0 !important;
  float: none !important;
  padding: 12px 32px !important;
}
.block-list li em{
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
}
.block-list li p{
  padding: 0 !important;
  font-size: 18px;
  line-height: 21px;
  margin: 0 !important;
}
.block-list li p:before{display: none;}
.block-list-holder{
  overflow: hidden;
  position: relative;
}
.table-holder{
  overflow: hidden;
  position: relative;
}
.canceltooltip{
  float: right;
  margin: 0;
  position: absolute;
  left: 10px;
  top: 10px;
  border: none !important;
}
.canceltooltip img {display: block;}
.tab-content2  #chapers,
.tab-content2  #genesis-bar{display: none;}
.tab-content2 .myclass #genesis{display: none;}
.tab-content2 .myclass #genesis-bar,
.tab-content2 .myclass #chapers{display: block;}
#featuresShow,
#features-show2,
#features-show{
  z-index:99999999;
  height: 100%;
  padding: 0 0 0 56px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 3px;
}
#features-hide2,
#features-hide{
  position: relative;
  z-index: 9999999;
  height: 100%;
}
#view_advanced_information table td:hover p/*,
#remove_words_features_popup .control.control--checkbox:hover > p*/{text-decoration: underline;}

#view_advanced_information table td:hover .tooltip-holder.chart p{
  text-decoration: none;
}
/* dicta.css */
.top-header{
  padding: 9px 0;
  height: 37px;
  background-color: #ffffff;
}
.top-header.border{
  border-bottom: solid 1px #dfdfdf;
}
.top-header .dicta{
  font-size: 18px;
  line-height: 21px;
  margin: 0 9px 0 0;
  display: inline-block;
  vertical-align: middle;
}
.top-header .txt.add{
  font-size: 12px;
  line-height: 15px;
  display: inline-block;
  vertical-align: middle;
  padding: 2px 0 0;
}
.top-header .txt.add a{
  text-decoration: underline;
}
.top-header .link{
  text-decoration: none;
  font-size: 12px;
  line-height: 15px;
  box-shadow: none;
  padding: 0;
  margin: 6px 0 0;
  display: block;
}
.top-header .link:active,
.top-header .link:focus,
.top-header .link:hover{
  color: #000 !important;
  box-shadow: none !important;
}
.top-header .btn-group.open .dropdown-toggle{
  box-shadow: none;
}
.top-header .link img{
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 2px;
}
.top-header .btn-group{
  vertical-align: top;
  margin: -2px 0 0;
}
.top-header .dropdown{
  width: 157px;
}
.top-header .dropdown-menu{
  width: 255px;
  background-color: #ffffff;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
  border: solid 1px #e7e7e7;
  text-align: left;
  padding: 0 16px;
  margin: 12px 0 0;
  border-radius: 0;
  left: 24px !important;
  transform: inherit!important;
  top: 100%!important;
  will-change: inherit!important;
}
.top-header .dropdown-menu:after, .top-header .dropdown-menu:before {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.top-header .dropdown-menu:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}
.top-header .dropdown-menu:before {
  border-color: rgba(231, 231, 231, 0);
  border-bottom-color: #e7e7e7;
  border-width: 11px;
  margin-left: -11px;
}

.top-header .dropdown-menu li{
  font-size: 14px;
  line-height: 17px;
  border-top: solid 1px #d8d8d8;
}
.top-header .dropdown-menu li:first-child{
  border:none;
}
.top-header .dropdown-menu li a{
  display: block;
  font-size: 14px;
  padding: 14px 0 14px 5px;
}
.top-header .dropdown-menu li a:hover,
.top-header .dropdown-menu li.active a{
  border-radius: 0;
  background-color: inherit;
}
.top-header .dropdown-menu li span{
  width: 25px;
  display: inline-block;
  vertical-align: middle;
}
.top-header .dropdown-menu li img{
  display: inline-block;
  vertical-align: middle;
  margin: 0 5px 0 0;
}
.footer{
  overflow: hidden;
  padding: 12px 0;
  background-color: #fbfbfb;
  border-top: solid 1px #d8d8d8;
  float: left;
}
.footer .link{
  font-size: 12px;
  line-height: 15px;
  text-align: left;
  border-bottom: 1px solid #000;
  text-decoration: none;
}
.footer .link:focus,
.footer .link:hover{
  color: #000;
  text-decoration: none;
}
.modal-backdrop.show {
  filter: alpha(opacity=50);
  opacity: .5;
}

/* baron.css */
.baron__clipper {
  position: relative;
  overflow: hidden;
}
.baron__scroller {
  /*overflow-y: scroll;*/
  -ms-overflow-style: none;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  /* remove line to customize scrollbar in iOs */
}
.baron__scroller::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.baron__track {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}
.right .baron__track{
  right:-20px;
}
.left .baron__track{
  left: -13px;
  right: auto;
}
.baron._scrollbar .baron__track {
  display: block;
}
.baron__free {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}
.baron__bar {
  display: none;
  position: absolute;
  right: 5px;
  z-index: 1;
  width: 5px;
  background: #d8d8d8;
  border-radius: 10px;
}
.baron._scrollbar .baron__bar {
  display: block;
}
.baron__control {
  display: none;
}
#scrollable1{
  max-height: 96vh;
}
#scrollable3{
  height:85vh;
  background: #f7f7f7;
  padding: 0 0 200px;
}
.scrollable6,
.scrollable4{
  position: relative;}
#scrollable4{
  max-height:35vh;
}
.classes-area #scrollable12{padding: 30px 49px 10vh;}
#scrollable12{
  max-height: 65vh;
}

.scrollable25{
  max-height: 68vh;
}
.scrollable25 .frame{
  min-height: inherit;
}
/*.tab-content .row.no-gutters{*/
  /*height: inherit !important;*/
/*}*/
#scrollable255{
  max-height: 78vh;
  padding-bottom: 10vh;
}
#scrollable5,
#scrollable55{
  /*max-height:504px;*/
  max-height:680px;
}
#scrollable26{
  /*max-height: 680px;*/
  max-height: 66vh;
  padding-bottom: 10vh;
}
#remove_words_features_popup #scrollable26{max-height: 64vh;}
#scrollable266{
  max-height: 71vh;
  padding-bottom: 10vh;
}
#scrollable555{
  /*max-height:560px;*/
  max-height: 75vh;
  padding-bottom: 10vh;
}
#scrollable-box{
  /*max-height:80vh;*/
  max-height:435px;
}

.baron{
  overflow-y: auto;
  height: 100%;
}
.baron__bar.add,
.baron__bar.add1 {background: rgba(0, 0, 0, 0.3);}

.side .baron .baron__track{
  right: auto;
  left: 0;
}
.side .baron .baron__bar{
  right: auto;
  left: 4px;
}
.mybaron .baron__bar {right: 23px;}
.nav>li>a:focus, .nav>li>a:hover {
  text-decoration: none;
  background-color: #fff;
}
#classes_for_analysis_popup #home{
  overflow: hidden;
  height: 100% !important;
}
.empty-class{
  height: 100px;
  text-indent: -9999px;
  overflow: hidden;
  border: none !important;
}
#remove_words_features_popup #scrollable26{max-height: 64vh;}
@media screen and (max-height: 900px){
  #remove_words_features_popup #scrollable26{max-height: 60vh;}
}
@media screen and (max-height: 800px){
  .scrollable25{max-height: 62vh;}
  #mypopup-classification .scrollable25{max-height: 56vh;}
  #remove_words_features_popup #scrollable26{max-height: 54vh;}
}
@media screen and (max-height: 760px){
  /*#scrollable12 {max-height: 45vh;}*/
  /*#scrollable25 {max-height: 55vh;}*/
  #scrollable266 {max-height: 65vh;}
  #remove_words_features_popup #scrollable26{max-height: 54vh;}
  .scrollable25{max-height: 60vh;}
  #mypopup-classification .scrollable25{max-height: 56vh;}
  .control-group.check{min-height: 400px;}
}
@media screen and (max-height: 599px){#remove_words_features_popup #scrollable26{max-height: 50vh;}}
@media screen and (max-width:999px){
  .top-header .dropdown-menu{left: -18px !important;}
  .top-header .dropdown-menu:after, .top-header .dropdown-menu:before{left: 75% !important;}
}
@media screen and ( max-width: 768px ){
  .top-header .dicta{
    margin: 0 !important;
    font-size: 16px !important;
  }
  .top-header .link{
    float: right;
    margin: 7px 0 0;
  }
  .top-header .txt.add{
    font-size: 11px !important;
  }
  .logo{margin: 0 0 4px;}
  .btn-header{margin-top: 10px;}
  .top-header .dropdown-menu{
    left: -34px !important;
  }
  .top-header .dropdown-menu:after, .top-header .dropdown-menu:before{
    left: 75%;
  }
  .inner .logo{
    width: 290px;
    height: 66px;
    margin: 0 auto 30px;
  }
  #top .btn-custom {width: 100%;}
}
@media screen and ( max-width: 1539px ){
  .top-header .dropdown-menu{
    right: 0;
    left: auto !important;
  }
  .top-header .dropdown-menu:after, .top-header .dropdown-menu:before {left: 80%;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue